<div class="adventure-type-page-container" *ngIf="!loading">
    <app-title-background
      [locationDto]="getCorrectLocation()"
      style="margin-bottom: 30px"
      [style]="isMobile ? 'position: sticky; top: 0' : ''"
    />
  <div>
    <app-destinations-countries
      [border]="true"
      [type]="'adventure'"
      [adventureId]="locationDto.id ?? null"
      (firstLoading)="loadingEmit($event)"
      (emitContinents)="setContinentId($event)"
      style="margin-bottom: 58px"
    />
    <app-section [style]="window.innerWidth < 550 ? 'margin-top: 1.5rem;' : ''">
      <app-main-busy-bee
        [texts]="[
        {text: ['Стоит ', ' '], fontFamily: 'pd', fontStyle: 'italic'},
        {text: ['увидеть', 'Recommended'],},
      ]"
        [cards]="busyBeeCard"
      />
    </app-section>
    <app-section [style]="window.innerWidth < 550 ? 'margin-top: -40px' : ''">
      <app-main-best-hotels
        [texts]="[
        {text: ['Рекомендуемые ', 'Finest '], fontFamily: 'pd', fontStyle: 'italic'},
        {text: ['отели', 'Hotels']}
      ]"
        [search]="true"
        [subtitle]="true"
        [cards]="hotelCards"
      />
    </app-section>
  </div>
  <div class="sticky-section-wrapper" style="background: var(--background-color)">
    <app-section class="sticky-section">
      <app-main-busy-bee
        [cards]="CardsArrayVoyages"
        [texts]="mainVoyagesTitle"
      />
    </app-section>
  </div>
  <app-section-scroller class="overlapping-content">
    <app-main-destinations (ClickOnActive)="goToDestination($event)" (loadingEmit)="loadCircle($event)"/>
  </app-section-scroller>
</div>
<app-admin-preview [adminDisplay]="adminDisplay" [uncorrectedUrl]="uncorrectedUrl" [displayPageFalse]="displayPageFalse"/>
